import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a265a56")

_pushScopeId("data-v-7a265a56")
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "left-content flex1" }
const _hoisted_3 = { class: "display-flex board-content" }
const _hoisted_4 = { class: "display-flex board-content" }
const _hoisted_5 = { class: "display-flex" }
const _hoisted_6 = { class: "margin-right20px flex1" }
const _hoisted_7 = { class: "chart-content" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  id: "counts-container",
  class: "container margin-top35px"
}, null, -1)
const _hoisted_9 = { class: "margin-right20px flex1" }
const _hoisted_10 = { class: "chart-content" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  id: "times-container",
  class: "container margin-top35px"
}, null, -1)
const _hoisted_12 = { class: "right-content" }
const _hoisted_13 = { class: "record-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_item_title = _resolveComponent("item-title")
  const _component_card_icon = _resolveComponent("card-icon")
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_entry_record = _resolveComponent("entry-record")
  const _component_enlarge_image = _resolveComponent("enlarge-image")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_item_title, {
        name: _ctx.$wordList.ProperAllTextReminder
      }, null, 8, ["name"]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reminderData, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "margin-right20px flex1",
            key: index,
            id: "test111"
          }, [
            _createVNode(_component_card_icon, {
              "card-data": item,
              text: _ctx.reminderNum[item.name],
              onClick: ($event: any) => (_ctx.goPath(item.path))
            }, null, 8, ["card-data", "text", "onClick"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_item_title, {
        name: _ctx.$wordList.ProperAllTextComInfo
      }, null, 8, ["name"]),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infoData, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "margin-right20px flex1",
            key: index
          }, [
            _createVNode(_component_card_icon, {
              "card-data": item,
              text: _ctx.infoNum[item.name],
              onClick: ($event: any) => (_ctx.goPath(item.path))
            }, null, 8, ["card-data", "text", "onClick"])
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_item_title, {
            name: _ctx.$wordList.ProperAllTextAccessAuthStatic
          }, null, 8, ["name"]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_secondary_nav, {
              navs: _ctx.countsNav,
              active: _ctx.activeCountsItem,
              onChoose: _ctx.changeCountsChart,
              resetWidth: 100
            }, null, 8, ["navs", "active", "onChoose"]),
            _hoisted_8
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_item_title, {
            name: _ctx.$wordList.ProperAllTextDoorStatic
          }, null, 8, ["name"]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_secondary_nav, {
              navs: _ctx.TimesNav,
              active: _ctx.activeTimesItem,
              onChoose: _ctx.changeTimesChart,
              resetWidth: 100
            }, null, 8, ["navs", "active", "onChoose"]),
            _hoisted_11
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_item_title, {
        name: _ctx.$wordList.ProperAllTextEntryRecord
      }, null, 8, ["name"]),
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recordData, (item, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode(_component_entry_record, {
              "record-data": item,
              onClick: _ctx.enlargeImg
            }, null, 8, ["record-data", "onClick"])
          ]))
        }), 128))
      ])
    ]),
    (_ctx.isShowEnlargeImage)
      ? (_openBlock(), _createBlock(_component_enlarge_image, {
          key: 0,
          picAddress: _ctx.picAddress,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowEnlargeImage=false))
        }, null, 8, ["picAddress"]))
      : _createCommentVNode("", true)
  ]))
})